import React, { useState, useEffect, useCallback } from 'react';
import api from '../services/api';
import s from './PedidosOrcamentos.module.css';

const STATUS_OPTS = [
  { v: '',             l: 'Todos os status' },
  { v: 'pendente',     l: 'Pendente' },
  { v: 'implementada', l: 'Implementada' },
  { v: 'ignorada',     l: 'Ignorada' },
];
const IMPACTO_OPTS = [
  { v: '',      l: 'Todos os impactos' },
  { v: 'nfe',   l: 'NF-e' },
  { v: 'nfce',  l: 'NFC-e' },
  { v: 'ambos', l: 'NF-e + NFC-e' },
];
const PRIORIDADE_OPTS = ['alta', 'media', 'baixa'];

const CORES_STATUS = {
  pendente:     { bg: '#fef3c7', fg: '#92400e', l: 'Pendente' },
  implementada: { bg: '#dcfce7', fg: '#166534', l: 'Implementada' },
  ignorada:     { bg: '#f1f5f9', fg: '#64748b', l: 'Ignorada' },
};
const CORES_PRIORIDADE = {
  alta:  { bg: '#fee2e2', fg: '#b91c1c', l: 'Alta' },
  media: { bg: '#e0e7ff', fg: '#3730a3', l: 'Média' },
  baixa: { bg: '#f1f5f9', fg: '#64748b', l: 'Baixa' },
};
const LABEL_IMPACTO = { nfe: 'NF-e', nfce: 'NFC-e', ambos: 'NF-e + NFC-e' };

const Badge = ({ cor }) => (
  <span style={{ background: cor.bg, color: cor.fg, padding: '2px 8px', borderRadius: 10, fontSize: 11.5, fontWeight: 700, whiteSpace: 'nowrap' }}>
    {cor.l}
  </span>
);

const fmtData = d => {
  if (!d) return '—';
  try { return new Date(d.slice ? d.slice(0, 10) + 'T12:00:00' : d).toLocaleDateString('pt-BR'); }
  catch { return d; }
};

export default function NotasTecnicas() {
  const [lista, setLista]           = useState([]);
  const [fStatus, setFStatus]       = useState('');
  const [fImpacto, setFImpacto]     = useState('');
  const [carregando, setCarregando] = useState(false);
  const [verificando, setVerificando] = useState(false);
  const [aviso, setAviso]           = useState('');
  const [erro, setErro]             = useState('');
  const [detalhe, setDetalhe]       = useState(null); // NT aberta no modal
  const [salvando, setSalvando]     = useState(false);

  const carregar = useCallback(async () => {
    setCarregando(true); setErro('');
    try {
      const params = {};
      if (fStatus)  params.status  = fStatus;
      if (fImpacto) params.impacto = fImpacto;
      const { data } = await api.get('/notas-tecnicas', { params });
      setLista(data);
    } catch (err) {
      setErro(err.response?.data?.erro || 'Erro ao carregar notas técnicas.');
    } finally { setCarregando(false); }
  }, [fStatus, fImpacto]);

  useEffect(() => { carregar(); }, [carregar]);

  const verificarAgora = async () => {
    setVerificando(true); setAviso(''); setErro('');
    try {
      const { data } = await api.post('/notas-tecnicas/verificar');
      setAviso(data.mensagem);
      carregar();
    } catch (err) {
      setErro(err.response?.data?.erro || 'Falha ao consultar o portal da SEFAZ.');
    } finally { setVerificando(false); }
  };

  const abrirDetalhe = nt => setDetalhe({
    ...nt,
    data_obrigatoriedade: nt.data_obrigatoriedade ? nt.data_obrigatoriedade.slice(0, 10) : '',
    observacoes: nt.observacoes || '',
  });

  const salvarDetalhe = async () => {
    if (!detalhe) return;
    setSalvando(true); setErro('');
    try {
      await api.put(`/notas-tecnicas/${detalhe.id}`, {
        status:               detalhe.status,
        prioridade:           detalhe.prioridade,
        impacto:              detalhe.impacto,
        data_obrigatoriedade: detalhe.data_obrigatoriedade || null,
        observacoes:          detalhe.observacoes,
      });
      setDetalhe(null);
      carregar();
    } catch (err) {
      setErro(err.response?.data?.erro || 'Erro ao salvar.');
    } finally { setSalvando(false); }
  };

  const setD = (k, v) => setDetalhe(d => ({ ...d, [k]: v }));

  return (
    <>
      <div className={s.erpWrap}>
        {/* Barra azul */}
        <div className={s.titleBar}>
          <span>📜</span> Notas Técnicas SEFAZ
        </div>

        {/* Filtros + ações */}
        <div className={s.headerRow}>
          <div className={s.headerGroup}>
            <span className={s.headerLabel}>Status</span>
            <select className={s.selectErp} style={{ width: 160 }}
              value={fStatus} onChange={e => setFStatus(e.target.value)}>
              {STATUS_OPTS.map(o => <option key={o.v} value={o.v}>{o.l}</option>)}
            </select>
          </div>
          <div className={s.headerGroup}>
            <span className={s.headerLabel}>Impacto</span>
            <select className={s.selectErp} style={{ width: 160 }}
              value={fImpacto} onChange={e => setFImpacto(e.target.value)}>
              {IMPACTO_OPTS.map(o => <option key={o.v} value={o.v}>{o.l}</option>)}
            </select>
          </div>
          <div style={{ flex: 1 }} />
          <button className={`${s.btnErp} ${s.btnErpPrimario}`}
            onClick={verificarAgora} disabled={verificando}
            title="Consulta o portal nacional da NF-e agora (a verificação automática roda toda segunda-feira às 8h)">
            {verificando ? 'Consultando portal…' : '🔄 Verificar Agora'}
          </button>
        </div>

        {aviso && <div style={{ padding: '6px 12px', background: '#dcfce7', color: '#166534', fontSize: 13 }}>{aviso}</div>}
        {erro  && <div style={{ padding: '6px 12px', background: '#fee2e2', color: '#b91c1c', fontSize: 13 }}>{erro}</div>}

        {/* Grid */}
        <div style={{ flex: 1, overflowY: 'auto', background: '#fff' }}>
          <table className={s.modalTabela} style={{ width: '100%' }}>
            <thead>
              <tr>
                <th style={{ width: 100 }}>Código</th>
                <th>Título</th>
                <th style={{ width: 95 }}>Publicação</th>
                <th style={{ width: 115 }}>Obrigatoriedade</th>
                <th style={{ width: 105 }}>Impacto</th>
                <th style={{ width: 110 }}>Status</th>
                <th style={{ width: 85 }}>Prioridade</th>
              </tr>
            </thead>
            <tbody>
              {lista.length === 0 && (
                <tr><td colSpan={7} style={{ textAlign: 'center', padding: 18, color: '#888' }}>
                  {carregando ? 'Carregando…' : 'Nenhuma nota técnica com estes filtros.'}
                </td></tr>
              )}
              {lista.map(nt => {
                const vencida = nt.status === 'pendente' && nt.data_obrigatoriedade &&
                  new Date(nt.data_obrigatoriedade) < new Date(new Date().toDateString());
                return (
                  <tr key={nt.id} onClick={() => abrirDetalhe(nt)} title="Clique para ver detalhes">
                    <td style={{ fontWeight: 700, whiteSpace: 'nowrap' }}>{nt.codigo}</td>
                    <td>
                      {nt.titulo}
                      {nt.descricao && (
                        <div style={{ fontSize: 11.5, color: '#667', marginTop: 2 }}>
                          {nt.descricao.slice(0, 140)}{nt.descricao.length > 140 ? '…' : ''}
                        </div>
                      )}
                    </td>
                    <td>{fmtData(nt.data_publicacao)}</td>
                    <td style={vencida ? { color: '#b91c1c', fontWeight: 700 } : undefined}>
                      {fmtData(nt.data_obrigatoriedade)}{vencida ? ' ⚠' : ''}
                    </td>
                    <td>{LABEL_IMPACTO[nt.impacto] || nt.impacto}</td>
                    <td><Badge cor={CORES_STATUS[nt.status] || CORES_STATUS.pendente} /></td>
                    <td><Badge cor={CORES_PRIORIDADE[nt.prioridade] || CORES_PRIORIDADE.media} /></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>

        <div className={s.statusBar}>
          {lista.length} nota(s) técnica(s) | Verificação automática: toda segunda-feira às 8h | Fonte: Portal Nacional da NF-e
        </div>
      </div>

      {/* ── Modal de detalhes ── */}
      {detalhe && (
        <div className={s.overlay} onMouseDown={e => e.target === e.currentTarget && setDetalhe(null)}>
          <div className={s.modal} style={{ maxWidth: 640 }}>
            <div className={s.modalTitle}>📜 {detalhe.codigo}</div>
            <div className={s.modalBody} style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              <div style={{ fontWeight: 700, fontSize: 14 }}>{detalhe.titulo}</div>
              {detalhe.descricao && <div style={{ fontSize: 13, color: '#445' }}>{detalhe.descricao}</div>}
              <div style={{ fontSize: 13 }}>
                Publicada em <strong>{fmtData(detalhe.data_publicacao)}</strong>
                {' · '}
                <a href={detalhe.url_oficial} target="_blank" rel="noopener noreferrer"
                  style={{ color: '#1565ff', fontWeight: 600 }}>
                  🔗 Abrir no portal oficial da NF-e
                </a>
              </div>

              <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginTop: 4 }}>
                <label style={{ fontSize: 12, fontWeight: 600, display: 'flex', flexDirection: 'column', gap: 3 }}>
                  Status
                  <select className={s.selectErp} value={detalhe.status} onChange={e => setD('status', e.target.value)}>
                    {STATUS_OPTS.filter(o => o.v).map(o => <option key={o.v} value={o.v}>{o.l}</option>)}
                  </select>
                </label>
                <label style={{ fontSize: 12, fontWeight: 600, display: 'flex', flexDirection: 'column', gap: 3 }}>
                  Prioridade
                  <select className={s.selectErp} value={detalhe.prioridade} onChange={e => setD('prioridade', e.target.value)}>
                    {PRIORIDADE_OPTS.map(p => <option key={p} value={p}>{CORES_PRIORIDADE[p].l}</option>)}
                  </select>
                </label>
                <label style={{ fontSize: 12, fontWeight: 600, display: 'flex', flexDirection: 'column', gap: 3 }}>
                  Impacto
                  <select className={s.selectErp} value={detalhe.impacto} onChange={e => setD('impacto', e.target.value)}>
                    {IMPACTO_OPTS.filter(o => o.v).map(o => <option key={o.v} value={o.v}>{o.l}</option>)}
                  </select>
                </label>
                <label style={{ fontSize: 12, fontWeight: 600, display: 'flex', flexDirection: 'column', gap: 3 }}
                  title="Data em que a NT passa a ser exigida pela SEFAZ (consta no PDF da NT) — alimenta os alertas do Dashboard">
                  Obrigatória a partir de
                  <input type="date" className={s.inputErp} value={detalhe.data_obrigatoriedade}
                    onChange={e => setD('data_obrigatoriedade', e.target.value)} />
                </label>
              </div>

              <label style={{ fontSize: 12, fontWeight: 600, display: 'flex', flexDirection: 'column', gap: 3 }}>
                Observações
                <textarea rows={3} value={detalhe.observacoes}
                  style={{ padding: '6px 8px', fontSize: 13, border: '1px solid #ccc', borderRadius: 4, resize: 'vertical' }}
                  placeholder="Anotações internas sobre esta NT (o que afeta, o que foi feito...)"
                  onChange={e => setD('observacoes', e.target.value)} />
              </label>
            </div>
            <div className={s.modalFooter}>
              <button className={`${s.btnErp} ${s.btnErpPrimario}`} onClick={salvarDetalhe} disabled={salvando}>
                {salvando ? 'Salvando…' : 'Salvar'}
              </button>
              <button className={s.btnErp} onClick={() => setDetalhe(null)}>Fechar</button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
